"use client";

import { useReportWebVitals } from "next/web-vitals";

interface WebVitalsInterface {
  debug: boolean;
}

export function WebVitals({ debug }: WebVitalsInterface) {
  const typeMetric: string[] = [];

  useReportWebVitals((metric) => {
    if (!typeMetric.includes(metric.name)) {
      typeMetric.push(metric.name);
      debug && console.log(metric);
    }
  });

  return null;
}
